import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import { Box, Button, Flex, TextInput, Tooltip } from '@applyboard/crystal-ui';
import { EyeHiddenOutlineIcon, EyeOutlineIcon } from '@applyboard/ui-icons';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function PasswordInput(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Password' : _ref$label,
    value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    invalid = _ref.invalid,
    required = _ref.required,
    helpText = _ref.helpText;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isMasked = _React$useState2[0],
    setIsMasked = _React$useState2[1];
  return _jsxs(Flex, {
    gap: 6,
    direction: "row",
    align: "start",
    children: [_jsx(Flex.Item, {
      basis: "90%",
      children: _jsx("div", {
        "data-testid": isMasked ? 'masked-password' : 'unmasked-password',
        children: _jsx(TextInput, {
          type: isMasked ? 'password' : 'text',
          label: label,
          value: value,
          onBlur: onBlur,
          onChange: onChange,
          invalid: invalid,
          required: required,
          helpText: helpText
        })
      })
    }), isMasked ? _jsx(Box, {
      pt: 8,
      children: _jsx(Tooltip, {
        enabled: true,
        label: "Show password",
        placement: "top",
        children: _jsx(Button, {
          "aria-label": "show password",
          emphasis: "outlined",
          leadIcon: EyeHiddenOutlineIcon,
          onClick: function onClick() {
            return setIsMasked(function (currentIsMasked) {
              return !currentIsMasked;
            });
          }
        })
      })
    }) : _jsx(Box, {
      pt: 8,
      children: _jsx(Tooltip, {
        enabled: true,
        label: "Hide password",
        placement: "top",
        children: _jsx(Button, {
          "aria-label": "hide password",
          emphasis: "outlined",
          leadIcon: EyeOutlineIcon,
          onClick: function onClick() {
            return setIsMasked(function (currentIsMasked) {
              return !currentIsMasked;
            });
          }
        })
      })
    })]
  });
}